import { get, post } from '../../../../api/index';
export const toNoticeList = params => get(`/api/notice/v1/list`, params); // 公告列表
export const toNoticeInfo = params => get(`/api/notice/v1/info`, params); // 公告详情
